// angular dependencies
import { inject, type Signal } from '@angular/core';

// fantaz dependencies
import { GameHistoryService } from '@fantaz/shared/data-access/api';
import {
  injectQuery,
  keepPreviousData,
} from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

export function userGameHistoryQuery(params: {
  eventPrototypeUuid: Signal<string>;
  page: Signal<number>;
  limit: Signal<number>;
  forfeited: boolean;
  gameType: string;
  orderBy: string;
  orderDir: string;
}) {
  const service = inject(GameHistoryService);

  return injectQuery(() => ({
    queryKey: [
      'user-game-history',
      params.eventPrototypeUuid(),
      params.gameType,
      params.page(),
      params.limit(),
    ],
    queryFn: () =>
      lastValueFrom(
        service.getGameHistory({
          eventPrototypeUuid: params.eventPrototypeUuid(),
          pageIndex: params.page(),
          pageSize: params.limit(),
          forfeited: params.forfeited,
          gameType: params.gameType,
          orderBy: params.orderBy,
          orderDir: params.orderDir,
        }),
      ),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  }));
}
